import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AccordionContentComponent,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/drawer-content/accordion-content.component';
import { NgForOf } from '@angular/common';
import {
  OpenQuoteRequestsItem
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/quote-requests.types';
import {
  DrawerContentWrapperComponent
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/drawer-content-wrapper/drawer-content-wrapper.component';

@Component({
  selector: 'sbd-account-portal-frontend-delivery-details',
  standalone: true,
  imports: [
    AccordionContentComponent,
    DrawerContentWrapperComponent,
    NgForOf,
  ],
  templateUrl: './delivery-details.component.html',
})
export class DeliveryDetailsComponent {
  @Input() selectedQR: OpenQuoteRequestsItem | null = null;
  @Input() queuedQR: OpenQuoteRequestsItem[] = [];
  @Input() subtotal: number = 0;
  @Input() activeOpenedQR: any = {};

  @Output() getShippingMethodValueEvent = new EventEmitter<{ event: any, key: string, index: number }>();
  @Output() updatedOpenQREvent = new EventEmitter<OpenQuoteRequestsItem>();

  getShippingMethodValue(event: any, key: string, index: number) {
    this.getShippingMethodValueEvent.emit({ event, key, index });
  }

  updateSelectedQuoteOption(event: OpenQuoteRequestsItem) {
    this.updatedOpenQREvent.emit(event);
  }


  protected readonly Object = Object;
}
